import { useCallback } from 'react';
import type { IScreensLogging } from 'shared/src/api/types';
import { bridge } from 'shared/src/utils';

type LogClickFeedbackParams = {
  logging?: IScreensLogging;
  feedbackEventKey: string;
};

export const useLogClickFeedback = (screen?: string) => {
  return useCallback(
    ({ logging, feedbackEventKey }: LogClickFeedbackParams) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_FEEDBACK',
        analytics: {
          ...logging?.analytics,
          ...(screen != null && screen !== '' && { SCREEN: screen }),
          FEEDBACK: feedbackEventKey,
        },
        ably_only_log: logging?.ably_only_log,
      });
    },
    [screen],
  );
};
